const TOKEN_EXPIRY_HOURS = 8;

export default {
    getToken: () => {
        const tokenData = localStorage.getItem('tokenData');
        
        if (!tokenData) {
            return null;
        }

        try {
            const { token, expiresAt } = JSON.parse(tokenData);
            
            // Vérifier si le token a expiré
            if (Date.now() > expiresAt) {
                // Token expiré, le supprimer
                localStorage.removeItem('tokenData');
                return null;
            }
            
            return token;
        } catch (e) {
            // Si le parsing échoue, supprimer les données corrompues
            localStorage.removeItem('tokenData');
            return null;
        }
    },

    setToken: (token) => {
        const expiresAt = Date.now() + (TOKEN_EXPIRY_HOURS * 60 * 60 * 1000); // 8 heures en ms
        const tokenData = JSON.stringify({ token, expiresAt });
        localStorage.setItem('tokenData', tokenData);
    },

    removeToken: () => {
        localStorage.removeItem('tokenData');
    },

    // Utilitaire pour vérifier le temps restant (en minutes)
    getTimeRemaining: () => {
        const tokenData = localStorage.getItem('tokenData');
        
        if (!tokenData) {
            return 0;
        }

        try {
            const { expiresAt } = JSON.parse(tokenData);
            const remaining = expiresAt - Date.now();
            return remaining > 0 ? Math.floor(remaining / (60 * 1000)) : 0;
        } catch (e) {
            return 0;
        }
    },
};
